module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIHZpZXdCb3g9IjAgMCA5IDkiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGQ9Ik0xLjUsNi4zbDMtM2wzLDMiIHN0cm9rZT0iI0YzRjNGMyIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIC8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flow-direction.svg
// module id = pIjb
// module chunks = 40